import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const AuthenticationHeader = ({ showHelp = false }) => {
  const handleHelpClick = () => {
    // Help functionality can be implemented here
    console.log('Help clicked');
  };

  return (
    <header className="fixed top-0 right-0 left-0 z-[100] bg-background border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Help Button (Left side in RTL) */}
          {showHelp && (
            <button
              onClick={handleHelpClick}
              className="inline-flex items-center px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-smooth focus-ring rounded-md">
              <Icon name="HelpCircle" size={20} className="ml-2" />
              راهنما
            </button>
          )}

          {/* Logo (Right side in RTL) */}
          <Link
            to="/"
            className="flex items-center space-x-reverse space-x-3 focus-ring rounded-lg p-2">
            <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
              <Icon name="Scale" size={20} color="white" />
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-semibold text-foreground">
                ایران‌‌‌‌‌‌داد
              </span>
              <span className="text-xs text-muted-foreground -mt-1">
                IranDaaD
              </span>
            </div>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default AuthenticationHeader;
